// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "screen and (max-width: 600px)";
var _3 = "wrapper-UYdiY";
var _4 = "levelImage-Myoeo";
var _5 = "header-3YKNN";
var _6 = "level-TH6Bt";
var _7 = "info-1zzGF";
var _8 = "number-1cgei";
export { _1 as "__esModule", _2 as "mobile", _3 as "wrapper", _4 as "levelImage", _5 as "header", _6 as "level", _7 as "info", _8 as "number" }
export default { "__esModule": _1, "mobile": _2, "wrapper": _3, "levelImage": _4, "header": _5, "level": _6, "info": _7, "number": _8 }
